import React, { PropsWithChildren, useMemo, useState } from 'react';
import { SearchContextState } from './SearchContext.types';
import { SearchContext, initialSearchContextState } from './SearchContext';
import { Cruise } from 'types';

// PENDING: define SearchProviderProps type
//          move search related data from the CruiseSearchContextProvider to this provider
function SearchProvider({ children }: PropsWithChildren) {
  const [results] = useState<Array<Cruise>>(initialSearchContextState.results);
  const [total] = useState<number>(initialSearchContextState.total);
  const [isSearching] = useState<boolean>(initialSearchContextState.isSearching);
  const value = useMemo<SearchContextState>(() => ({
    results,
    total,
    isSearching,
  }), [isSearching, results, total]);

  return (
    <SearchContext.Provider value={value}>
      {children}
    </SearchContext.Provider>
  );
}

export default SearchProvider;